// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"1d4c9b01","409":"d25c4d7f","453":"7ec8dce4","772":"eb237d6b","814":"20fc3c2d","841":"c90871c4"}[chunkId] + ".chunk.js";
};